import CompanyList from '@Company/views/CompanyList.vue';
import CompanyProfile from '@Company/views/CompanyProfile.vue';
import CompleteRegister from '@Company/views/CompleteRegister.vue';
import PointCloudUtilityManagement from '@Admin/views/PointCloudUtilityManagement.vue';
import permissions from '@Share/config/permissions';

export default [
  {
    path: '/manage-companies',
    name: 'companies',
    component: CompanyList,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Companies',
      permissions: [permissions.CompaniesManagement.View],
    },
  },
  {
    path: '/profile',
    name: 'profile',
    component: CompanyProfile,
    meta: {
      requiresAuth: true,
      layout: 'accountLayout',
      title: 'Profile',
      permissions: [permissions.Users.View],
    },
  },
  {
    path: '/Companies/:id/Complete',
    name: 'complete-company',
    component: CompleteRegister,
    meta: {
      layout: 'auth-layout',
      requiresAuth: false,
      title: 'Register Company'
    },                                  
  },
  {
        path: '/pointCloudUtility',
        name: 'PointCloudUtilityManagement',
        component: PointCloudUtilityManagement,
        meta: {
          title: 'Point Cloud Utility',
          requiresAuth: true,
          layout: 'accountLayout',
          permissions: [permissions.CompaniesManagement.Update],
        },
      },
  
];
